import { render, staticRenderFns } from "./SalesRanking.vue?vue&type=template&id=4fdc37c8&scoped=true"
import script from "./SalesRanking.vue?vue&type=script&lang=js"
export * from "./SalesRanking.vue?vue&type=script&lang=js"
import style0 from "./SalesRanking.vue?vue&type=style&index=0&id=4fdc37c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdc37c8",
  null
  
)

export default component.exports